import { Observable, of, Subject, forkJoin } from "rxjs";
import { VariableIncomeOperation as VariableIncomeOperationModel } from '@models/variable-income-operation.model'
import { StockExchange } from "@app/core/models/stock-exchange.model";
import { TradableAsset } from "@app/core/models/tradable-asset.model";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { environment } from '@env/environment'
import { Currency } from "@app/core/models/currency.model";
import { ClearingService } from "@app/core/services-api/clearing.service";
import { BrokerService } from "@app/core/services-api/broker.service";
import { Broker } from "@app/core/models/broker.model";
import { Clearing } from "@app/core/models/clearing.model";
import { Fund } from "@app/core/models/fund.model";
import { FundService } from "@app/core/services-api/fund.service";
import { PlaceOfSettlement } from "@models/place-of-settlement.model";
import {catchError, map, tap } from "rxjs/operators";
import { CounterParty } from "@models/counter-party.model";
import { Fundo } from "@app/features/master/criar-grupos-de-investimento/criar-grupos-de-investimento.model";
import { ParametersSearchForEyesComponent } from "@app/features/parameters/search-for-eyes/parameters-search-for-eyes.component";
import { CashLastro } from '@app/core/models/cash-lastro.model';
import { SettlementInstruction } from "@app/core/models/settlement-instruction.model";
import { SelectionModel } from '@angular/cdk/collections'
import { CashFlowSWAP } from '@app/core/models/cash-flow-swap.model';
import { OptionExercice } from '@app/core/models/option-exercice.model';
import { DatePipe } from '@angular/common';
import { throwError } from 'rxjs';


const BASE_PATH = environment.basePathExternal
const BASE_PATH_EXTERNAL = environment.basePath
const COUNTERPARTY_PATH =environment.basePath 

@Injectable({
  providedIn: 'root',
})
export class SharedVariable {
  constructor(
    private datePipe: DatePipe,
    private httpClient: HttpClient,
    private clearingService: ClearingService,
    private brokerService: BrokerService,
    private fundService: FundService,
  ) { }
   
  public loaderForFundsAndDhashboards : boolean = false ;
  public selectedItemBroker = null
  public checkValueOfInvestmentGroup :[] =[]
  public GinstitutionCodeCaixa: any;
  public checkOperationType: string;
  public includePositions: string;
  public zipBase64: any;
  // Images carousel pour le dashboard home
  public carouselImages: any[] = [];
  public getFund: string
  public loaderForDashboard: boolean = false;
  public fundCotas:string
  public getoperationDateBCotas :any
  public getoperationDateBRv :any
  public getoperationDateRv: any
  public sellType: any
  public getoperationDateEmprestimo :any
  public getoperationDateTermoAcoes: any
  getExecutionTermoAcoes: any
  checkmovementTypeTermOp : any
  public GinstitutionCodeOperacoes: any;
  public GinstitutionCodeCotas: any;
  public GinstitutionCodeInsumos: any;
  public resultUsers: any;
  public GinstitutionCode: any;
  public forEyesComponent: ParametersSearchForEyesComponent
  public fundList: Fund[] = [];
  public fundListDashboards: Fund[] = [];
  public stockExchangeList: StockExchange[] = [];
  private stockExchangeListLoading = false; // Flag pour éviter les appels multiples
  public tradableAssetList: TradableAsset[];
  public currencyList: Currency[] = [];
  private currencyListLoading = false; // Flag pour éviter les appels multiples
  public brokerList: Broker[] = [];
  private brokerListLoading = false; // Flag pour éviter les appels multiples
  public placeOfSettlementList: PlaceOfSettlement[] = [];
  public clearingList: Clearing[] = [];
  private clearingListLoading = false; // Flag pour éviter les appels multiples
  public counterPartyList: CounterParty[];
  private counterPartyListLoading = false; // Flag pour éviter les appels multiples
  public fetchLastroByPapel: any;
  public fetcchAnticipationCarteria: any = null;
  public prevFetcchAnticipationCarteria: any = null;
  public anticipationCompromisadaValues: any;
  public lastroList: any[];
  public instructionFundList: Fund[];
  private instructionFundListLoading = false; // Flag pour éviter les appels multiples
  public lastroServiceCount = 0;
  public movementTypeTermOp: any = ""
  public statusMessageUpload: any = ""
  public fundListFundGroup: any[];
  public reportListGroup: any[];
  public selectionReport = new SelectionModel<any>(true, []);
  public selectionFundos = new SelectionModel<any>(true, []);
  public relatorioIsSelected: boolean = false;
  public groupCarteiraIsSelected: boolean = false;
  public filtredFundGroup: any;
  public persistenceforEdit: boolean = false;
  public valueFundCaixa: any = ""
  public mailUser: any = ""
  public userSso: any = ""
  public inputFund: string = "";
  public inputAsset: string = "";
  public datePNL: Date = null;
  public ptfTitle: string;
  public instructionFund:any;
  public datePos : Date
  public isSelectCSV : boolean = false;
  public reportType : string;
  fundListAuthorisaExtra: any[] = [];
  listPTFBYUSER: any[] = []
  listAllPtfs : any[]=[]
  listPTFBYUSERForFilter: string = "";
  listPTFBYUSERForFilterForEyes: string = "";
  fundListAuthorisaExtrapar: any[] = [];
  listSubjetOfFourEyeses: any[] = [];
  listSubjetRetroactiveOperation: any[] = [];
  isFeitoDirty: boolean = false;
  public form: any;
  public stockexchange: StockExchange;
  public tradableasset: TradableAsset;
  public currency: Currency;
  public isCaceis = false
  public groupCreationEnabled: boolean;
  public selectedAnbimaFunds: any[] = [];
  public fileListAnbima: any[] = [];
  public fileListAnbimaForZip: any[] = [];
  public fileListAnbimaForXml: any[] = [];
  public cambioBrokerList: any[] = [];
  private cambioBrokerListLoading = false; // Flag pour éviter les appels multiples
  public selection = new SelectionModel<any>(true, []);
  public daysOfweek: any[];
  public daysOfMonth: any = {};
  public weekOfMonth: any;
  public dayOfweek: any;
  public daysOfMonthInYear: any;
  public monthOfYear: any;
  public selectedDays: any[];
  public radioCkeck: string = 'perDay';
  public radioCkeckYears: string = 'perDay';
  public inputValue: any
  public primeiraSelected: any
  public segundaFeiraSelected: any
  public inputValueYear: any
  public monthSelected: any
  public primeiraSelectedForYear: any
  public segundaFeiraSelectedForYear: any
  public monthSelectedForYear: any
  public reportSelected: any
  public operationFunctionEmprestimo: any
  public funCodeEmprestimo: any
  public positionDateEmprestimo: any
  public tipoMovimento: any;
  public shortBTC: any;
  public fundGuaranty :any;
  public carteiraDeGarantia: any;
  public insumosCode:any;
  public insumosStartDate:any;
  public insumosEndDate:any
  
  public isDashboardHomeActive: boolean = true;
  public idDashboardOpeartionsActive : boolean = false;
  public isDashboardOnlineCashActive: boolean = false;
  public isDashboardCotasActive: boolean = false;
  public isDashboardPLActive: boolean = false;
  public isDashboardAccumulatedManagementActive: boolean = false;
  public isDashboardInsumosPendentesActive: boolean = false;

  // Dashboard operation log variables
  public dashboardOperationLogStatus: string = null;
  public dashboardOperationLogDate: string = null;

  // Dashboard caixa online log variables
  public dashboardCaixaOnlineLogStatus: string = null;
  public dashboardCaixaOnlineLogDate: Date = null;

  // Dashboard status cotas log variables
  public dashboardStatusCotasLogStatus: string = null;
  public dashboardStatusCotasLogDate: string = null;

  public isBlockedRf: any
  public isBlockedCotas :any
  public isBlockedRv :any
  public sharedCriteria : any;
  public weekOfYear: any;
  public dayOfWeekOfYear: any;
  public monthOfYears: any;
  public groupOfFundList: any;
  public additionalFund: any = [];
  public reportedOperationFunds: any;
  public formattedStartDate: String;
  public formattedEndDate: String;
  fundListofFunfGroup = new SelectionModel<any>(true, []);
  settlementInstruction = ["VariableIncome", "FixedIncome", "Repo", "Unit", "BlockUnblockFund", "BlockUnblockRF", "BlockUnblockRV", "Futur", "TermOperation","StockLoan"]
  paymentOrder = ["Ingresso","Cambio", "CashInOrCashOut"]
  optionExercice = ["ExerciceOfOptionOfFutur", "ExerciceOfOptionOfRV"]

  public filteredGroups: any[] = [];

  public userGroup = new Subject<any[]>()

  public cashFlowSWAP: CashFlowSWAP[] = []
  public clientCodeSwap: string
  public swapOperationDate: Date
  public inputSwap: string = "";
  public isIntegrated : boolean = false;

  public isIntegratedAnticipation : boolean =false;

  public showForEyesConfirm() {
    this.forEyesComponent.HandleTabNavigation()
  }

  public getStockExchangeCode(): any {
    return this._stockExchangeCode;
  }
  public getSelectedFundCode(): any {
    return this._fundCode;
  }
  public getSelectedFundCodeFutur(): any {
    return this._fundCodeFutur;
  }
  public setStockExchangeCode(value: any) {
    this._stockExchangeCode = value;
  }
  public setFundCode(value: any) {
    this._fundCode = value;
  }
  public setFundCodeFutur(value: any) {
    this._fundCodeFutur = value;
  }
  public setTradeDate(value: any) {
    this._tradeDate = value;
  }
  public setTradeDateFutur(value: any) {
    this._tradeDateFutur = value;
  }
  public getTradeDate(): any {
    return this._tradeDate;
  }
  public getTradeDateFutur(): any {
    return this._tradeDateFutur;
  }
  private selectedUploadedFile: any;
  private _stockExchangeCode: any;
  private _fundCode: any;
  private _tradeDate: any;
  private _fundCodeFutur: any;
  private _tradeDateFutur: any;
  private _selectedUploadedFileItems: Observable<VariableIncomeOperationModel[]>;

  public get selectedUploadedFileItems(): Observable<VariableIncomeOperationModel[]> {
    return this._selectedUploadedFileItems;
  }
  public set selectedUploadedFileItems(value: Observable<VariableIncomeOperationModel[]>) {
    this._selectedUploadedFileItems = value;
  }


  setGinstitutionCodeCaixa(val) {
    this.GinstitutionCodeCaixa = val
  }
  setGinstitutionCodeOperacoes(val) {
    this.GinstitutionCodeOperacoes = val
  }
  setGinstitutionCodeCotas(val) {
    this.GinstitutionCodeCotas = val
  }
  setGinstitutionCodeInsumos(val) {
    this.GinstitutionCodeInsumos = val
  }
  getSelectedUploadedFile() {
    return this.selectedUploadedFile;
  }

  setSelectedUploadedFile(selectedUploadedFile: any) {
    this.selectedUploadedFile = selectedUploadedFile;
  }

  getStockExchanges() {
    // Évite les appels multiples pendant le chargement
    if (this.stockExchangeListLoading || this.stockExchangeList.length > 0) {
      return;
    }
    this.stockExchangeListLoading = true;
    this.getStockexchangePossibleValues().subscribe(stockExchanges => {
      this.stockExchangeList = stockExchanges;
      this.stockExchangeListLoading = false;
    }, error => {
      console.log("Error when getting data ..." + error);
      this.stockExchangeListLoading = false;
    })
  }

  /****************Lastro************* */
  /*********************************** */

  getCounterPartyList() {
    // Évite les appels multiples pendant le chargement
    if (this.counterPartyListLoading || (this.counterPartyList && this.counterPartyList.length > 0)) {
      return;
    }
    this.counterPartyListLoading = true;
    this.counterPartyList = [];
    this.getCounterPartyService().subscribe(data => {
      this.counterPartyList = data;
      this.counterPartyListLoading = false;
    }, error => {
      console.log("Error when getting data ..." + error);
      this.counterPartyListLoading = false;
    })
  }

  getCurrency() {
    // Évite les appels multiples pendant le chargement
    if (this.currencyListLoading || this.currencyList.length > 0) {
      return;
    }
    this.currencyListLoading = true;
    this.getCurrencyPossibleValues().subscribe(Currency => {
      this.currencyList = Currency;
      this.currencyListLoading = false;
    }, error => {
      console.log("Error when getting data ..." + error);
      this.currencyListLoading = false;
    })
  }

  getBrokerList() {
    // Évite les appels multiples pendant le chargement
    if (this.brokerListLoading || this.brokerList.length > 0) {
      return;
    }
    this.brokerListLoading = true;
    this.brokerService.findAll().subscribe(data => {
      this.brokerList = data;
      this.brokerListLoading = false;
    }, error => {
      console.log("Error when getting data ..." + error);
      this.brokerListLoading = false;
    })
  }

  getClearingList() {
    // Évite les appels multiples pendant le chargement
    if (this.clearingListLoading || this.clearingList.length > 0) {
      return;
    }
    this.clearingListLoading = true;
    this.clearingService.find().subscribe(data => {
      this.clearingList = data;
      this.clearingListLoading = false;
    }, error => {
      console.log("Error when getting data ..." + error);
      this.clearingListLoading = false;
    })
  }

  getFundList() {
    this.fundService.findAllByPtfCode().subscribe(data => {
      this.fundList = data.filter(item=> item.status =="Ativo");
      this.fundListDashboards = data;
      this.loaderForFundsAndDhashboards = true
    })
  }

  getInstructionFundList() {
    // Évite les appels multiples pendant le chargement
    if (this.instructionFundListLoading || (this.instructionFundList && this.instructionFundList.length > 0)) {
      return;
    }
    this.instructionFundListLoading = true;
    this.fundService.findFundoCotaAll().subscribe(data => {
      this.instructionFundList = data;
      this.instructionFundListLoading = false;
    }, error => {
      console.log("Error when getting data ..." + error);
      this.instructionFundListLoading = false;
    })
  }

  /**
   * Charge toutes les données globales nécessaires en parallèle avec forkJoin
   * Utilisé par les modules qui ont besoin de plusieurs listes
   * Chaque liste a sa propre protection contre les appels multiples
   */
  loadGlobalData(): void {
    // Préparer les observables à charger (seulement ceux qui ne sont pas déjà chargés)
    const requests: { [key: string]: Observable<any> } = {};

    if (!this.currencyListLoading && this.currencyList.length === 0) {
      this.currencyListLoading = true;
      requests['currency'] = this.getCurrencyPossibleValues();
    }

    if (!this.stockExchangeListLoading && this.stockExchangeList.length === 0) {
      this.stockExchangeListLoading = true;
      requests['stockExchange'] = this.getStockexchangePossibleValues();
    }

    if (!this.instructionFundListLoading && (!this.instructionFundList || this.instructionFundList.length === 0)) {
      this.instructionFundListLoading = true;
      requests['instructionFund'] = this.fundService.findFundoCotaAll();
    }

    if (!this.clearingListLoading && this.clearingList.length === 0) {
      this.clearingListLoading = true;
      requests['clearing'] = this.clearingService.find();
    }

    if (!this.brokerListLoading && this.brokerList.length === 0) {
      this.brokerListLoading = true;
      requests['broker'] = this.brokerService.findAll();
    }

    if (!this.counterPartyListLoading && (!this.counterPartyList || this.counterPartyList.length === 0)) {
      this.counterPartyListLoading = true;
      requests['counterParty'] = this.getCounterPartyService();
    }

    // Si aucune requête n'est nécessaire, on sort
    if (Object.keys(requests).length === 0) {
      return;
    }

    // Exécuter toutes les requêtes en parallèle
    forkJoin(requests).subscribe({
      next: (results) => {
        // Assigner les résultats
        if (results['currency']) {
          this.currencyList = results['currency'];
          this.currencyListLoading = false;
        }
        if (results['stockExchange']) {
          this.stockExchangeList = results['stockExchange'];
          this.stockExchangeListLoading = false;
        }
        if (results['instructionFund']) {
          this.instructionFundList = results['instructionFund'];
          this.instructionFundListLoading = false;
        }
        if (results['clearing']) {
          this.clearingList = results['clearing'];
          this.clearingListLoading = false;
        }
        if (results['broker']) {
          this.brokerList = results['broker'];
          this.brokerListLoading = false;
        }
        if (results['counterParty']) {
          this.counterPartyList = results['counterParty'];
          this.counterPartyListLoading = false;
        }
        console.log('✅ Global data loaded successfully');
      },
      error: (error) => {
        console.error('❌ Error loading global data:', error);
        // Réinitialiser les flags en cas d'erreur
        this.currencyListLoading = false;
        this.stockExchangeListLoading = false;
        this.instructionFundListLoading = false;
        this.clearingListLoading = false;
        this.brokerListLoading = false;
        this.counterPartyListLoading = false;
      }
    });
  }

  /**
   * Charge les données spécifiques à Payment Order (en plus des données globales)
   * Utilisé par le guard Payment Order et le module upload
   */
  loadPaymentOrderData(): void {
    // D'abord charger les données globales
    this.loadGlobalData();
    
    // Ensuite charger cambioBrokerList spécifique à Payment Order
    if (!this.cambioBrokerListLoading && this.cambioBrokerList.length === 0) {
      this.getCambioBroker();
    }
  }


  getStockExchangeByCode(code: string): StockExchange {
    return this.stockExchangeList.find(element => element.stockExchangeCode === code);
  }

  getCounterPartyByCode(code: string): CounterParty {
    let counterpartyObject: CounterParty[]
    if (this.counterPartyList) {
      counterpartyObject = this.counterPartyList.filter(element => element.counterPartyCode === code);
      if (counterpartyObject[0]?.codContraparte == null && counterpartyObject[0]?.counterPartyCode) {
        counterpartyObject[0].codContraparte = counterpartyObject[0]?.counterPartyCode
      }
    }
    console.log("Counterparty retrieved", counterpartyObject[0])
    return counterpartyObject[0]
  }

  /*getLastroByCode(code: string): any {
    return this.lastroList.find(element => element.idLastro === code);
  }*/
  /************************Lastro*************** */
  /*  getLastroByCode(lastroCode: string, tradableAssetCode: string): any {
     this.getLastroService(tradableAssetCode).subscribe(data => {
       this.lastroList = [{...data}];
       return this.lastroList.find(element => element.idLastro === lastroCode);
     });
   }*/
  /******************************************** */

  getTradableAssetByCode(ta: SettlementInstruction): Observable<SettlementInstruction> {
    if (ta.tradableAssetCode) {
      let params = new HttpParams().set('code', ta.tradableAssetCode);
      return this.httpClient.get<TradableAsset>(
        `${BASE_PATH_EXTERNAL}/bff/papel/findByInstrumentCode`, { params: params })
        .pipe(map((result: TradableAsset) => {
          ta.tradableasset = result;
          return ta;
        }));
    }
  }

  getTradableAssetByCodeVendaOperation(ta: SettlementInstruction): Observable<SettlementInstruction> {

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    const formattedDate = this.datePipe.transform( ta.operationDate, 'yyyy-MM-dd');

    let body = {

      "fundCode": ta.fundCode,
      "positionDate": formattedDate,
      "idBoleta": "1",
      "pageSize": "700000",
      "pageNumber": "1",
      // "codBolsa": "00123093",
      "tradableAssetCode": "null"
    }
    if (ta.tradableAssetCode) {
      return this.httpClient.post<any>(
        `${BASE_PATH}/operation/getPosition`, body, { headers: headers })
        .pipe(map((result) => {
          if (result.length){
            ta.tradableasset = result.filter(it => it.codPapel == ta.tradableAssetCode)[0];
          }
          else{
            ta.tradableasset = {"instrumentCode" : ta.tradableAssetCode,"availableQuantity":0,"issuer":null,"name":null,"tradableAssetType":null,"type":null,"papelCode":null,"papelName":null}
          }
          
          return ta;
        }));
    }
  }
  getTradableAssetByCodeblockUnblockRVOperation(ta: SettlementInstruction): Observable<SettlementInstruction> {

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })

    let body = {

      "fundCode": ta.fundCode,
      "positionDate": ta.operationDate,
      "idBoleta": "1",
      "pageSize": "700000",
      "pageNumber": "1",
      // "codBolsa": "00123093",
      "tradableAssetCode": "null"
    }
    if (ta.tradableAssetCode) {
      return this.httpClient.post<any>(
        `${BASE_PATH}/operation/getPosition`, body, { headers: headers })
        .pipe(map((result) => {
          if (result.length){
            const value =result.filter(it => it.codPapel == ta.tradableAssetCode)[0];
            value.qtdeDisponivel=parseInt(value.qtdeDisponivel, 10)
            value.qtdeBloqueada=parseInt(value.qtdeBloqueada, 10)
            value.quantidadeTotal=parseInt(value.quantidadeTotal, 10)
            ta.tradableasset  = value

            //ta.tradableasset =  {"papelCode" : value.papelCode,"papelName":value.papelName,"qtDisponible":qtDisponible,"qtBloq":qtBloq,"quantidadeTotal":quantidadeTotal}
          }
          else{
            ta.tradableasset = {"instrumentCode" : ta.tradableAssetCode,"availableQuantity":0,"issuer":null,"name":null,"tradableAssetType":null,"type":null,"papelCode":null,"papelName":null}
          }
          
          return ta;
        }));
    }
  }

  getTradbleAssetBlockUnblockRf(ta: SettlementInstruction): Observable<SettlementInstruction> {
    let params = new HttpParams()
    params = params.append('id_boleta', "3");
    params = params.append('pageSize', "70000");
    params = params.append('pageNumber', "0");
    if (ta.tradableAssetCode) {
      return this.httpClient.get<any[]>(`${COUNTERPARTY_PATH}/bff/papel/findByBolsa`, { params: params })
        .pipe(
          map((result) => {
            ta.tradableasset = result.filter(it => it.instrumentCode == ta.tradableAssetCode)[0];
            return ta;
          }),
          catchError((error) => {
              return of(ta);
          })
        );
    }

  }

  getTradbleAssetBlockUnblockRV(ta: SettlementInstruction): Observable<SettlementInstruction> {
    if(ta.operationType.toString() == "BLOCK" ){
      let body = {}
      const formattedDate = this.datePipe.transform( ta.operationDate, 'yyyy-MM-dd');
      body = {

        "fundCode": ta.fundCode,
        "positionDate": formattedDate,
        "idBoleta": "1",
        "pageSize": "700000",
        "pageNumber": "1",
         "codBolsa":ta.stockExchangeCode,
        "tradableAssetCode": "null"
      }
      if (ta.tradableAssetCode) {
        return this.httpClient.post<any>(
          `${BASE_PATH}/operation/getPosition`, body)
          .pipe(map((result) => {
            let positions = [];
            result.forEach(element => {
              positions.push({
                papelCode: element.codPapel,
                papelName: element.name,
                qtDisponible: parseInt(element.qtdeDisponivel, 10),
                qtBloq:parseInt(element.qtdeBloqueada, 10),
                quantidadeTotal:parseInt(element.quantidadeTotal, 10),
                stockExchangeCode: element.codBolsa
              });
            });
            if (positions.length){
              ta.tradableasset = positions.filter(it => it.papelCode == ta.tradableAssetCode&&it.stockExchangeCode==ta.stockExchangeCode)[0];
            }
            else{
              ta.tradableasset = {"papelCode" : ta.tradableAssetCode,"qtDisponible":0}
            }
            
            return ta;
          }),
          catchError((error) => {
              return of(ta);
          })
        );;
      }

    }
  
    else{
     
        let paramsunblock = new HttpParams()
        paramsunblock = paramsunblock.append('codeFund', ta.fundCode);
        paramsunblock = paramsunblock.append('idBoleta', "7");
        return this.httpClient.get<any[]>(
          `${BASE_PATH}/unblock/position` , { params: paramsunblock })
          .pipe(map((result: any[]) => {
            let list = [];
            result.forEach(element => {
              list.push({
                operationCode : element.operationCode,
              papelCode: element.codePapel,
              papelName: element.name,
              qtBloq:parseInt(element.qtdeBloq, 10),
              broker : element.brocker,
              blokingReason : element.motivo,
              clearing : element.clearing,
              stockExchangeCode: element.codBolsa
              } );
            });
            if(list.length){
              ta.tradableasset = list.filter(e => e.operationCode == ta.operationCode)[0];
            }
            
            return ta;
          }));
  
        
    }
  
    
  
}
  getTradbleAssetBlockUnblockCotas(settlementInst: SettlementInstruction): Observable<SettlementInstruction> {
    let params = new HttpParams()
    let tradableasset :any
    let month = settlementInst.operationDate.getMonth() + 1
    params = params.append('positionDate', settlementInst.operationDate.getFullYear() + "-" + month + "-" + settlementInst.operationDate.getDate());
    params = params.append('idBoleta', "6");
    params = params.append('codeFund', settlementInst.fundCode);
    params = params.append('pageSize', "70000");
    params = params.append('pageNumber', "0");
    if (settlementInst.operationType.toString() == "BLOCK") {
      params = params.append('blocked', "true");
    }
    else {
      params = params.append('blocked', "false");

    }
    if (settlementInst.tradableAssetCode) {
      return this.httpClient.get<any[]>(
        `${BASE_PATH}/findUnblockBCotas`, { params: params })
        .pipe(map((result) => {
          result.forEach(el=>{
            if(el.papelCode === settlementInst.tradableAssetCode){
              if (settlementInst.operationType.toString()=="BLOCK"){
                tradableasset={
                  "code": el.code,
                  "codeSelicCetip": el.codeSelicCetip,
                  "fundType": el.fundType,
                  "localCustodia": el.localCustodia,
                  "papelCode": el.papelCode,
                  "papelName": el.papelName,
                  "qtDisponible": el.qtDisponible,
                  "valorDisponible": el.valorDisponible
                  }
              }
              
                else{
                  tradableasset={
                    "code": el.code,
                    "codeSelicCetip": el.codeSelicCetip,
                    "fundType": el.fundType,
                    "localCustodia": el.localCustodia,
                    "papelCode": el.papelCode,
                    "papelName": el.papelName,
                    "qtBloq": el.qtBloq,
                    "valorBloq": el.valorBloq
                    }
                }
            }
          })
          settlementInst.tradableasset =tradableasset;
          return settlementInst;
        }),
        catchError((error) => {
            return of(settlementInst);
        })
      );
  }

}
getBlockUnblockInstructionFundForCotasPosition(ta: SettlementInstruction): Observable<SettlementInstruction> {
  if (ta.operationType.toString() == "BLOCK") {
    let params = new HttpParams()
  const formattedDate = this.datePipe.transform( ta.operationDate, 'yyyy-MM-dd').replace(/-/g, '');;
  params = params.append('positionDate', formattedDate);
  params = params.append('idBoleta', "COT");
  params = params.append('fundCode', ta.fundCode);
  if (ta.tradableAssetCode) {
    return this.httpClient.get<any[]>(
      `${BASE_PATH}/operation/getExternalFundwithPosition`, { params: params })
      .pipe(map((result) => {
        if (result == null){
          return ta
        }
        let list = [];
        result.forEach(element => {
          list.push({
            papelCode: element.codigoId,
            papelName: element.nome,
            cetipCode: element?.codeSelicCetip,
            cnpj: element.fundCNPJ,
            isin: element.isin,
            valorDisponible:parseFloat(element.vlrDisponivel),
            qtDisponible: parseFloat(element.qtDisponivel)
          } );
        });
        ta.tradableasset = list.filter(it => it.papelCode == ta.tradableAssetCode)[0];
        return ta;
      }));
  }
  }
  else{
    if(ta.operationType.toString() == "UNBLOCK"){
      let paramsunblock = new HttpParams()
      paramsunblock = paramsunblock.append('codeFund', ta.fundCode);
      paramsunblock = paramsunblock.append('idBoleta', "6");
      return this.httpClient.get<any[]>(
        `${BASE_PATH}/unblock/position` , { params: paramsunblock })
        .pipe(map((result: any[]) => {
          let list = [];
          result.forEach(element => {
            list.push({
              papelCode: element.codePapel,
              papelName: element.name,
              cetipCode: element?.operationCode,
              operationCode: element?.operationCode,
              cnpj: element?.fundCNPJ,
              isin: element?.isin,
              blockingReason : element.motivo,
              broker : element.brocker,
              valorDisponible:parseInt(element.qtdisponible, 10), 
              qtDisponible:parseInt(element.qtdeBloq, 10), 
              clearing : element.codBolsa,
            } );
          });
          if(list.length){
            ta.tradableasset = list.filter(e => e.operationCode == ta.operationCode)[0];
          }
          
          return ta;
        }));

      }
  }
  

}




  getInstructionFundForCotasPosition(ta: SettlementInstruction): Observable<SettlementInstruction> {
    let params = new HttpParams()
    let month
    month = ta.operationDate.getMonth() + 1
    if (month<10){
     month = "0" +month.toString()
    }
    let day
    day =ta.operationDate.getDate()
    if (day <10){
      day = "0"+ day.toString()
    }
    else{
      day = day.toString()
    }
    params = params.append('positionDate', ta.operationDate.getFullYear().toString() + month + day);
    params = params.append('idBoleta', "COT");
    params = params.append('fundCode', ta.fundCode);
    if (ta.instructionFundCode) {
      return this.httpClient.get<any[]>(
        `${BASE_PATH}/operation/getExternalFundwithPosition`, { params: params })
        .pipe(map((result) => {
          if (result == null){
            return ta
          }
          let list = [];
          result.forEach(element => {
            let depo:string;
            if(element.depo){
              if(element.depo == "JCOT" || element.depo == "MX"){
                depo = "Interno"
              }else if(element.depo == "CETIP"){
                depo = "Clearing"
              }else if(element.depo == "GESTOR"){
                depo ="STR"
              }else{
                depo = element.depo;
              }
            }
            list.push({
              fundCode: element.codigoId,
              name: element.nome,
              cetipCode: element?.accountCetipSelic,
              cnpj: element.fundCNPJ,
              isin: element.isin,
              availableValor: element.vlrDisponivel,
              availableQuantity: element.qtDisponivel,
              depo:depo
              // availableValor availableQuantity
            } );
          });
          ta.instructionFund = list.filter(it => it.fundCode == ta.instructionFundCode)[0];
          return ta;
        }));
    }

  }
  getBlockigReason(ta: SettlementInstruction): Observable<SettlementInstruction> {
    let id_boleta
      if(ta.productType.toString() =="BlockUnblockRV"){
        id_boleta="7"
      }
      else if(ta.productType.toString() =="BlockUnblockFund"){
        id_boleta="6"
      }
      else{
        id_boleta="8"
      }
      return this.httpClient.get<any[]>(
        `${BASE_PATH_EXTERNAL}/bff/externaldata/motivobloqueio/boleta/`+id_boleta)
        .pipe(map((result) => {
          if (result == null){
            return ta
          }
          
          ta.blockingReason = result.filter(it => it.codBloqueio == ta.blockingReason)[0];
          return ta;
        }));
    

  }
  exerciceOfOptionOfFuturRVPosition(ta: OptionExercice): Observable<OptionExercice> {
    let month
      month = ta.tradeDate.getMonth() + 1
      if (month<10){
       month = "0" +month.toString()
      }
      let day
      day =ta.tradeDate.getDate()
      if (day <10){
        day = "0"+ day.toString()
      }
      else{
        day = day.toString()
      }
      let  body={
        fundCode: ta.clientCode,
        positionDate :ta.tradeDate.getFullYear().toString() +"-"+ month +"-"+ day,
        idBoleta: "12",
        pageSize : "700000",
        pageNumber : "1",
        
   }

    
    if (ta.optionCode) {
      let optCode = ta.optionCode.split("-")[0]
      return this.httpClient.post<any[]>(
        `${BASE_PATH}/operation/getPosition`, body)
        .pipe(map((result) => {
      
          ta.option = result.filter(it => (it.codPapel == optCode || it.codPapel+" " == optCode )&& (it.clientReference==ta.operationCode))[0];
          return ta;
        }));
    }

  }




  
  exerciceOfOptionOfFuturPosition(ta: OptionExercice): Observable<OptionExercice> {
    let month
      month = ta.tradeDate.getMonth() + 1
      if (month<10){
       month = "0" +month.toString()
      }
      let day
      day =ta.tradeDate.getDate()
      if (day <10){
        day = "0"+ day.toString()
      }
      else{
        day = day.toString()
      }
      let  body={
        fundCode: ta.clientCode,
        positionDate :ta.tradeDate.getFullYear().toString() +"-"+ month +"-"+ day,
        idBoleta: "11",
        pageSize : "700000",
        pageNumber : "1",
        
   }

    
    if (ta.optionCode) {
      let optCode = ta.optionCode.split("-")[0]
      return this.httpClient.post<any[]>(
        `${BASE_PATH}/operation/getPosition`, body)
        .pipe(map((result) => {
      
          ta.option = result.filter(it => ((it.codPapel == optCode || it.codPapel+" " == optCode) && (ta.maturityCode == it.codVencimento)&&(it.clientReference==ta.operationCode)))[0];
          return ta;
        }));
    }

  }



  getPositionTermOperation(ta: SettlementInstruction): Observable<SettlementInstruction> {
    let params = new HttpParams()
    let params1 = new HttpParams()
    const formattedDate = this.datePipe.transform( ta.operationDate, 'yyyy-MM-dd');
    
    if (ta.movementTypeTermOp=="TermSelling" || ta.execution==true){ 
      
      params = params.append('positionDate', formattedDate);
      params = params.append('codeFund', ta.fundCode);
    }
    if (ta.tradableAssetCode) {
      if(ta.movementTypeTermOp=="TermSelling" && ta.execution==true){
        params1 = params1.append('datePosition', formattedDate);
        params1 = params1.append('fundCode',  ta.fundCode);
        params1 = params1.append('idBoleta', "TAA");
        params1 = params1.append('pageSize', "70000");
        params1 = params1.append('pageNumber', "1");
        return this.httpClient.get<any[]>(
          `${BASE_PATH}/trading/termo/getanticipationtermosellposition`, { params: params1 })
          .pipe(map((result) => {
            let list = [];
            result.forEach(element => {
              list.push({
                instrumentCode: element.codPapel,
                name: element.papelName,
                availableQuantity:  parseInt(element.qtdeDisponivel, 10),
                vlrDisponivel: element.vlrDisponivel? parseInt(element.vlrDisponivel, 10):0,
                idOperacao :element.idOperacao,
                dateEmi:element.dateEmi,
                dataVenc:element.dataVenc
  
                // availableValor availableQuantity
              } );
            });
            ta.tradableasset = list.filter(it => it.instrumentCode == ta.tradableAssetCode)[0];
            return ta;
          }));
      }else{
        params = params.append('idBoleta', "1");
        return this.httpClient.get<any[]>(
          `${BASE_PATH}/getPositionTermoAcoes`, { params: params })
          .pipe(map((result) => {
            let list = [];
            result.forEach(element => {
              list.push({
                instrumentCode: element.codPapel,
                name: element.name,
                availableQuantity: element?.qtdeDisponivel
  
                // availableValor availableQuantity
              } );
            });
            ta.tradableasset = list.filter(it => it.instrumentCode == ta.tradableAssetCode)[0];
            return ta;
          }));
      }
      
    }

  }

  getMaxQuantityRenovacaoAnDevolecao(ta: SettlementInstruction): Observable<SettlementInstruction> {
    let params = new HttpParams()
    if (ta.fundCode) {
    params = params.append('codFund', ta.fundCode)
    params = params.append('pageSize', '70000')
    params = params.append('pageNumber', '1')

    const operationDate = this.datePipe.transform( ta.operationDate, 'yyyy-MM-dd');
    params = params.append('datPos', operationDate)
    if(this.operationFunctionEmprestimo == "Anticipation"){
      params = params.append('idBoleta', 'DEA')
    }
    if( this.operationFunctionEmprestimo == "Extension"){
      params = params.append('idBoleta', 'AEA')
    }
    return this.httpClient.get<any[]>(
      `${BASE_PATH}/trading/emprestimo/findByCodFundPag`,
      { params: params }).pipe(map((result) => {
          let list = [];
          result.forEach(element => {
            list.push({
              instrumentCode: element.codPapel,
              availableQuantity: element?.qtdeDispo,
              numberOperation:  element?.numOper
            } );
          });
          ta.tradableasset = list.filter(it => it.instrumentCode === ta.tradableAssetCode &&  it.numberOperation === ta.operationCode)[0];
          return ta;
        }));
    }

  }

  
  /**
   * get tradableAsset name
   * @param code
   * @returns
   */
  getTradableAssetNameByCodeOnly(code: string): Observable<any> {
    if (code) {
      let params = new HttpParams().set('code', code);
      return this.httpClient.get<any>(
        `${BASE_PATH_EXTERNAL}/bff/papel/findByInstrumentCode`, { params: params })
        .pipe(map((result: any) => {
          console.log("SharedVariable -> result", result)
          // ta.tradableasset = result;
          return result?.name;
        }));
    }
  }

  getCurrencyByCode(code: string): Currency {
    return this.currencyList.find(element => element.currencyCode === code);
  }

  // getInstructionUnitByCode(code: string): Fund {
  //   let FundObject=this.fundList.filter(element => element.fundCode === code);
  //   return FundObject[0]  }

  getBrokerByCode(code: string): Broker {
    return this.brokerList.find(element => element.brokerCode === code);
  }
  getBrokerByIDCambio(code: string): Broker {
    return this.cambioBrokerList.find(element => element.name === code);
  }
  getPlaceOfSettelement(code: string): PlaceOfSettlement {
    return this.placeOfSettlementList.find(element => element.identifier === code);
  }
  getCambioBroker() {
    // Évite les appels multiples pendant le chargement
    if (this.cambioBrokerListLoading || this.cambioBrokerList.length > 0) {
      return;
    }
    this.cambioBrokerListLoading = true;
    this.getPlaceOfSettlementService("22").subscribe(res => {
      this.cambioBrokerList = res;
      this.cambioBrokerListLoading = false;
      console.log("init broker size", this.cambioBrokerList.length);
    }, error => {
      console.log("Error when getting data ..." + error);
      this.cambioBrokerListLoading = false;
    })
  }
  getClearingByCode(code: string): Clearing {
    return this.clearingList.find(element => element.id === code);
  }
  getClearingByName(name: string): Clearing {
    return this.clearingList.find(element => element.name === name);
  }
  getFundByCode(code: string): Fund {
    if (this.fundList != null) {
      let FundObject = this.fundList.filter(element => element.fundCode === code);
      return FundObject[0]
    }

    return null

  }
  getAtivoByCode(code: string): Fund {
    let FundObject = this.instructionFundList.filter(element => element.fundCode === code);
    return FundObject[0]
  }
  getLastroCodeValue(code: string): any {
   return {
      "isin":code
    }
  }

  getBlockingReaonsByCode(tas: SettlementInstruction[]): Observable<SettlementInstruction[]> {
    let codes: String;
    tas.forEach((e) => {
      if (e.blockingReason && codes.indexOf(e.blockingReason) < 0) {
        codes = codes.concat(e.blockingReason + '|');
      }
    });
    return this.httpClient.get<any[]>(
      `${BASE_PATH_EXTERNAL}/bff/externaldata/motivobloqueio/` + codes)
      .pipe(map((result: any[]) => {
        tas.forEach(element => {
          element.blockreason = result.filter(e => e.codLocCust == element.blockingReason)[0];
        });
        return tas;
      }));

  }
  getBlockingReaonsByCodeSingle(ta: SettlementInstruction): Observable<SettlementInstruction> {
    if (ta.blockingReason) {
      return this.httpClient.get<any[]>(
        `${BASE_PATH_EXTERNAL}/bff/externaldata/motivobloqueio/` + ta.blockingReason)
        .pipe(map((result: any[]) => {
          ta.blockreason = result.filter(e => e.codLocCust == ta.blockingReason)[0];
          return ta;
        }));
    }
  }
  getOperacaoBlockUnblockRf(ta: SettlementInstruction): Observable<SettlementInstruction> {
    if (ta.lastroCode) {
      if(ta.operationType.toString() == "UNBLOCK"){
        let paramsunblock = new HttpParams()
        paramsunblock = paramsunblock.append('codeFund', ta.fundCode);
        paramsunblock = paramsunblock.append('idBoleta', "8");
        return this.httpClient.get<any[]>(
          `${BASE_PATH}/unblock/position` , { params: paramsunblock })
          .pipe(map((result: any[]) => {
            let list = [];
            result.forEach(element => {
              list.push({
                operationCode : element?.operationCode,
                emissor : element?.emiPapel,
                idLastro : element?.codePapel,
                qtdisponible : element?.qtdisponible,
                broker : element?.brocker,
                blockingReason : element?.motivo,
                clearing : element?.clearing,
              } );
            });
            if(list.length){
              ta.lastro = list.filter(e => e.operationCode == ta.operationCode)[0];
            }
            
            return ta;
          }));
        
      }else{

     
      let params = new HttpParams()
      const formattedDate = this.datePipe.transform( ta.operationDate, 'yyyy-MM-dd');
      params = params.append('positionDate', formattedDate);
      params = params.append('id_titulo',ta.tradableAssetCode);
      params = params.append('fundCode', ta.fundCode);
      params = params.append('id_boleta', "4");
      params = params.append('page_size', "70000");
      params = params.append('page_number', "0");
      return this.httpClient.get<any[]>(
        `${BASE_PATH}/lastro/findByTitulo` , { params: params })
        .pipe(map((result: any[]) => {
          if(result.length){
            ta.lastro = result.filter(e => e.idLastro == ta.lastroCode)[0];
          }
          
          return ta;
        }));
      }
    }
  }

  getPlaceOfSettlementByCode(ta: SettlementInstruction): Observable<SettlementInstruction> {
    if (ta.placeOfSettlementCode) {
      return this.httpClient.get<any>(
        `${BASE_PATH_EXTERNAL}/bff/externaldata/localcustodia/` + ta.placeOfSettlementCode)
        .pipe(map((result: any) => {
          if (result) {
            ta.placeofsettlements = { identifier: result.codLocCust, name: result.desLocCust } as PlaceOfSettlement

          }
          return ta

        }));
    }
  }

  getStockexchangePossibleValues(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${BASE_PATH_EXTERNAL}/bff/bolsa/all`)
  }

  getTradableassetPossibleValues(id_boleta: string
  ): Observable<any[]> {
    let params = new HttpParams().set('id_boleta', id_boleta);
    params = params.append('pageSize', "70000");
    params = params.append('pageNumber', "0");
    return this.httpClient.get<any[]>(
      `${BASE_PATH_EXTERNAL}/bff/papel/findByBolsa`,
      { params: params }
    )
  }

  getCurrencyPossibleValues(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${BASE_PATH_EXTERNAL}/bff/moeda/all`
    )
  }

  getBloachingReason(
    id_boleta: string
  ): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${environment.basePath}/bff/externaldata/motivobloqueio/boleta/` + id_boleta)
  }

  getPlaceOfSettlementService(
    id_boleta: string
  ): Observable<PlaceOfSettlement[]> {
    return this.httpClient.get<any[]>(
      `${environment.basePath}/bff/externaldata/localcustodia/boleta/` + id_boleta).pipe(
        map((data) => {
          let placeOfSettlementList = [];
          data.forEach(element => {
            placeOfSettlementList.push({
              identifier: element.codLocCust,
              name: element.desLocCust
            } as PlaceOfSettlement);
          });
          this.placeOfSettlementList = placeOfSettlementList
          return placeOfSettlementList;

        })
      )
  }

  getCounterPartyService(
  ): Observable<CounterParty[]> {
    return this.httpClient.get<any[]>(
      `${COUNTERPARTY_PATH}/bff/externaldata/proxy/contraparte/findall`).pipe(
        map((data) => {
          let counterPartyList = [];
          data.forEach(element => {
            counterPartyList.push({
              counterPartyCode: element.codContraparte,
              cetipCode: element.codIsin,
              name: element.name
            } as CounterParty);
          });
          return counterPartyList;

        })
      )
  }

  /* getLastroService(): Observable<any[]> {
     return this.httpClient
       .get<any>(
         `${LASTRO_PATH}/findByTitulo?id_titulo=TERMO`
       )
   }*/
  /***********************LASTRO SERVICE FOR RF INCLUDING POSITION********** */
  getLastroRFService(item): Observable<any[]> {
    if (item.tradableAssetCode !== undefined && item.tradableAssetCode !== null) {
      let params = new HttpParams()
      if (item.operationType == "SELL") {
        let month = parseInt(item.operationDate.getMonth()) + 1
        params = params.append('fundCode', item.fundCode);
        params = params.append('positionDate', item.operationDate.getFullYear() + "-" + month+"-" + item.operationDate.getDate());
      }
      params = params.append('id_titulo', item.tradableAssetCode);
      if(item.operationType == "SELL" &&item.sellType&&item.sellType=="ByOperationCode"){
        params = params.append('id_boleta', "44");

      }else{
        params = params.append('id_boleta', "4");

      }
     
      params = params.append('page_number', "0");
      params = params.append('page_size', "70000");
      return this.httpClient.get<any[]>(`${BASE_PATH}/lastro/findByTitulo`,
        { params })
    }
    return of(null)
  }



  /*********************Lastro Service***************** */
  getLastroService(tradableAssetCode: string): Observable<any[]> {
    if (tradableAssetCode !== undefined && tradableAssetCode !== null) {
      let params = new HttpParams()
      params = params.append('id_titulo', tradableAssetCode);
      params = params.append('id_boleta', "4");
      params = params.append('page_number', "0");
      params = params.append('page_size', "70000");
      return this.httpClient.get<any[]>(`${BASE_PATH}/lastro/findByTitulo`,
        { params })
    }
    return of(null)
  }

  getIdBoletaFromParentScreen(): string {
    let parentScreen = window.location.pathname;
    if (parentScreen.includes('VariableIncome')) {
      return "1";
    } else if (parentScreen.includes('future')) {
      return "2";
    } else if (parentScreen.includes('parent_fixed-income')) {
      return "3";
    }
    else if (parentScreen.includes('block-unblock-rf')) {
      return "3";
    }
    else if (parentScreen.includes('parent_repo')) {
      return "4";
    }
    else {
      return "1";
    }
  }


  /**************************************************** */

  availablePosition(body: any): Observable<any> {

    return new Observable(observer => {
      //lets pass a big int so we always get true
      //TODO : Replace this workaround
      observer.next(999999999999);
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    /* return this.httpClient.post<any>(
     `${BASE_PATH}/operation/availablePosition`,
     body,
    { headers: headers }
   ) */
  }

  //j'ai utilisé availablePositionRv pour ne pas faire des regressions dans les autres écran car l'implémentation du service ci-dessus est déja implémenté dans toutes les écrnas
  availablePositionRv(body: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    /* return new Observable(observer => {
      //lets pass a big int so we always get true
      //TODO : Replace this workaround
      observer.next(99999999999999);
    }); */

    return this.httpClient.post<any>(
      `${BASE_PATH}/operation/availablePosition`,
      body,
      { headers: headers }
    )
  }

  gerenarateOperationReport(body, operationType) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let url = BASE_PATH
    if(operationType === "settlementInstruction") {
      url += "/report/generateSettlementInstructionReport"
    } else if(operationType === "paymentOrder"){
      url += "/report/generatePaymentOrderReport"
    } else if(operationType === "optionExercice"){
      url += "/report/generateOptionExerciceReport"
    }
    return this.httpClient.post<any>(
      url,
      body,
      { headers: headers }
    )
  }

  downloadReport(base64Data: string, fileName: string, mimeType: string): void {
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
  
    window.URL.revokeObjectURL(url);
  }
  

  exportReport(isConsolidated: boolean, reportType: string, idOperation: string, productType: string) {

    const body = {
      idOperation: `${idOperation}`,
      fundCode: JSON.stringify(this.reportedOperationFunds),    
      isConsolidated: isConsolidated,
      endDate: this.formattedEndDate,
      startDate: this.formattedStartDate,
      productType: productType,
      reportType: reportType
    };

    let operationType
    if(this.settlementInstruction.includes(productType)) {
      operationType = "settlementInstruction"
    } else if(this.paymentOrder.includes(productType)) {
      operationType = "paymentOrder"
    } else if(this.optionExercice.includes(productType)) {
      operationType = "optionExercice"
    }

  this.gerenarateOperationReport(body, operationType).subscribe((res) => {
    const fileExtension = reportType === "PDF" ? ".pdf" : ".xlsx";
    const mimeType = reportType === "PDF"
      ? "application/pdf"
      : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    let fileName=""
    if(productType=="VariableIncome"){
     fileName = `EquityTradeTicket_${this.formattedStartDate}_${this.formattedEndDate || ''}_${isConsolidated ? 'Consolidado' : 'Analítico'}${fileExtension}`;

    }
    else{
     fileName = `${productType}_${this.formattedStartDate}_${this.formattedEndDate || ''}_${isConsolidated ? 'Consolidado' : 'Analítico'}${fileExtension}`;

    }

    this.downloadReport(res.report, fileName, mimeType);
  });
     
  }
}
